<template>
  <div class="kye-preview-file-list-wrapper">
    <file-item
      class="kye-preview-file-list-wrapper-item"
      v-for="item in fileList"
      :key="item.id"
      :url="item.url"
      :id="item.id"
      :fileName="item.name"
      :extendName="item.extendName"
      :canRemove="item.canRemove === false ? false : canRemove"
      :canDownload="canDownload"
      :canPreview="canPreview"
      @remove="remove"
      @download="download"
      @preview="preview"
    >
      <template slot="previewFileItem" slot-scope="{url, fileName, extendName}" v-if="$scopedSlots.previewFileItem">
        <slot name="previewFileItem" :url="url" :fileName="fileName" :extendName="extendName"></slot>
      </template>
    </file-item>
  </div>
</template>
<script>
import FileItem from './file-item.vue'
import { openPreview } from '../preview'
export default {
  name: 'KyePreviewList',
  components: { FileItem },
  props: {
    list: {
      type: Array,
      default: () => ([])
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    bizCode: String,
    bizId: String,
    imageProps: {
      type: Object,
      default: () => ({})
    },
    dialogOption: {
      type: Object,
      default: () => ({
        title: '图片查看',
        width: '700px',
      })
    },
    appendTo: [String, Object, HTMLElement],
    imgTypeList: Array,
    pdfTypeList: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'ofd']
    },
    mustPreivewType: {
      type: Array,
      default: () => []
    },
    isPrewFileToPdf: {
      type: Boolean,
      default: false
    },
    beforeDownload: Function,
  },
  watch: {
    bizId: {
      immediate: true,
      handler(val) {
        val !== undefined && this.init()
      }
    },
    bizCode: {
      immediate: true,
      handler(val) {
        val !== undefined && this.init()
      }
    },
    list: {
      immediate: true,
      handler(val) {
        this.data = val || []
      }
    }
  },
  data () {
    return {
      data: []
    }
  },
  computed: {
    fileList: {
      get () {
        return [...this.data]
      },
      set (val) {
        this.$emit('update:list', [...val])
      }
    }
  },
  methods: {
    // 删除
    remove(model) {
      console.log('删除文件!', model)
      this.$emit('remove', model)
    },
    // 下载
    async download(model) {
      const fn = this.beforeDownload
      if (fn && typeof fn === 'function') {
        const beforeDownload = fn(model)
        let flag = false
        if (beforeDownload && beforeDownload.then) {
          flag = await beforeDownload
        } else {
          flag = beforeDownload
        }
        if (flag === true) {
          return false
        }
      }
      window.erpOpen(model.url)
      this.$emit('download', model)
    },
    // 预览
    async preview (model) {
      const fn = this.beforePreview
      if (fn && typeof fn === 'function') {
        const beforePreview = fn(model)
        let flag = false
        if (beforePreview && beforePreview.then) {
          flag = await beforePreview
        } else {
          flag = beforePreview
        }
        if (flag === true) {
          return false
        }
      }
      openPreview({
        ...model,
        list: this.data,
        imageProps: this.imageProps,
        showDownload: this.showDownload,
        dialogOption: Object.assign({}, {
          title: '图片查看',
          width: '700px',
        }, this.$props.dialogOption),
        ...this.$listeners,
        appendTo: this.appendTo,
        imgTypeList: this.imgTypeList,
        pdfTypeList: this.$props.pdfTypeList,
        isPrewFileToPdf: this.$props.isPrewFileToPdf,
        mustPreivewType: this.$props.mustPreivewType
      })
      this.$emit('preview', model)
    },
    async init () {
      const list = await this.getDataFromBizConf()
      if (list) {
        this.data = list
        this.$emit('getFileList', list)
      }
    },
    // 根据bizCode bizId查询文件列表
    async getDataFromBizConf () {
      try {
        const { bizCode, bizId } = this
        if (!bizCode || !bizId) {
          return []
        }
        const data = await this.$http('file.getByBizCodeAndBizId', {
          bizCode,
          bizId,
        })
        return data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.kye-preview-file-list-wrapper {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  &-item {
    width: 200px;
    margin-bottom: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-list.vue